import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from './plugins/vue-i18n';
import pinia from './plugins/pinia';
import './plugins/ungp-components';
import './plugins/vee-validate';
import './plugins/sds-date-field';
import apolloClient from './plugins/apollo-client';
import { provide } from 'vue';
import { DefaultApolloClient } from '@vue/apollo-composable';

Vue.config.productionTip = false;

new Vue({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  router,
  vuetify,
  pinia,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
